import { useState } from "react";
import { Sparkles, Loader2, Link2, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

const FIELDS = ["title", "description", "category", "neighborhood", "zone_text", "venue_name", "address", "date", "time", "end_time", "price", "recurrence_freq"];
const field = "w-full px-4 py-2.5 rounded-xl bg-wyd-bg border border-white/10 text-white focus:ring-2 focus:ring-wyd-accent focus:outline-none";

const ModeBtn = ({ active, onClick, testid, icon, children }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium transition-colors duration-200 ${active ? "bg-wyd-accent text-wyd-bg" : "bg-white/5 text-wyd-muted hover:text-white"}`}>
    {icon} {children}
  </button>
);

export const AiExtractBox = ({ set }) => {
  const [mode, setMode] = useState("link");
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const extract = async () => {
    const v = value.trim();
    if (!v) { toast.error(mode === "link" ? "Inserisci un link" : "Incolla il testo dell'evento"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/extract-event", mode === "link" ? { url: v } : { text: v });
      FIELDS.forEach((k) => { if (data[k]) set(k, data[k]); });
      toast.success("Dati estratti: controllali prima di salvare");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="rounded-xl border border-wyd-accent/30 bg-wyd-accent/5 p-4 space-y-3" data-testid="admin-ai-box">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 text-sm font-semibold text-wyd-accent"><Sparkles size={14} /> Estrai con AI</span>
        <div className="flex gap-1.5">
          <ModeBtn active={mode === "link"} onClick={() => setMode("link")} testid="admin-ai-mode-link" icon={<Link2 size={12} />}>Link</ModeBtn>
          <ModeBtn active={mode === "text"} onClick={() => setMode("text")} testid="admin-ai-mode-text" icon={<FileText size={12} />}>Testo</ModeBtn>
        </div>
      </div>
      {mode === "link"
        ? <input data-testid="admin-ai-input" value={value} onChange={(e) => setValue(e.target.value)} placeholder="https://..." className={field} />
        : <textarea data-testid="admin-ai-input" rows={3} value={value} onChange={(e) => setValue(e.target.value)} placeholder="Incolla il testo del post o del messaggio..." className={field} />}
      <button type="button" data-testid="admin-ai-extract" onClick={extract} disabled={loading}
        className="w-full py-2.5 rounded-full bg-wyd-accent text-wyd-bg font-semibold text-sm flex items-center justify-center gap-2 disabled:opacity-60">
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />} {loading ? "Analizzo..." : "Compila il modulo"}
      </button>
    </div>
  );
};
